<template>
	<button type="button" @click.stop="isString(to) ? openUrl(to) : $router.push(to)"><slot /></button>
</template>

<script lang="ts" setup>
import type { RouteLocationRaw } from 'vue-router';
import bridge from '@thermenresorts/bridge';

defineProps<{
  to: RouteLocationRaw | string
}>()

function isString(value: unknown): value is string {
  return typeof value === 'string';
}

const openUrl = (url: string) => {
  bridge.sendMessage('pre-reservation-flow', 'redirect', { url });
};
</script>
